import { render, staticRenderFns } from "./MemberLabel.vue?vue&type=template&id=64e569e9&scoped=true&"
import script from "./MemberLabel.vue?vue&type=script&lang=js&"
export * from "./MemberLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e569e9",
  null
  
)

component.options.__file = "MemberLabel.vue"
export default component.exports